import "../styles/basket.css";
import { BasketContext } from "../contexts/BasketContexts";
import { useContext, useEffect } from "react";
import { BasketRow } from "./BasketRow";
import { NavBar } from "./navBar";
import { useState } from "react";
import { Footer } from "./Footer";

export const BasketPage = () => {
  const { basket } = useContext(BasketContext);
  const items = {};
  const shippingCost = 2.99;
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);

  for (let i = 0; i < basket.length; i++) {
    const movie = basket[i];
    const { title } = movie;
    items[title] = items[title]
      ? { movie, qty: items[title].qty + 1 }
      : { movie, qty: 1 };
  }

  //clear basket function to remove all items from basket
  const { setBasket } = useContext(BasketContext);
  const clrBasket = (basket) => {
    setBasket([]);
    return [...basket];
  };

  // subtotal for sidebar
  useEffect(() => {
    const sum = basket.reduce(
      (accumulator, currentValue) => accumulator + currentValue.price,
      0
    );
    const basketTotal = sum + shippingCost;
    setSubTotal(sum);
    setTotal(basketTotal);
    console.log(basketTotal);
  }, [basket]);

  //EMPTY BASKET DISPLAY
  const emptyBasket = () => {
    if (basket.length === 0) {
      return (
        <>
          <h1>Oops, it looks like your basket is empty!</h1>
        </>
      );
    } else {
    }
  };


  //html for basket page
  return (
    <>
      <NavBar />
      <div class="container" id="basket-page-container">
        <h1>Basket</h1>

        <div className="mobile-buttons">
            <div className="buttons">
              <button
                type="submit"
                class="btn btn-danger clrBasket"
                onClick={clrBasket}
                id="sidebar-item-mobile"
              >
                Clear Basket
              </button>
            </div>
            <div className="buttons">
              <button type="submit" class="btn" id="buy-btn" onClick={clrBasket}
                data-bs-toggle="modal"
                data-bs-target="#exampleModal">
                Buy
              </button>
            </div>
        </div>
        <div class="row">
          <div class="col-8" id="main-basket-container">
            <div class="container" id="main-basket-titles">
              <div class="row">
                <div class="col-7" id="basket-titles">
                  Product
                </div>
                <div class="col-3 qty" id="basket-titles">
                  Qty
                </div>
                <div class="col-2 subtotal" id="basket-titles">
                  Subtotal
                </div>
                <hr />
              </div>
              <div class="row" id="main-basket-area">
                {emptyBasket()}
                <ul className="list-group">
                  {Object.keys(items).map((key) => {
                    const item = items[key];
                    return (
                      <BasketRow
                        movie={item.movie}
                        poster={item.poster}
                        price={item.price}
                        qty={item.qty}
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
          <div class="col-4" id="basket-sidebar-main">
            <div class="container" id="basket-sidebar">
              <button
                type="submit"
                class="btn btn-danger clrBasket"
                id="sidebar-item"
                onClick={clrBasket}
              >
                Clear Basket
              </button>
              <div className="subTotal" id="sidebar-item">
                <h4>Subtotal</h4>
                <p>£{subTotal.toFixed(2)}</p>
              </div>
              <div className="shipping" id="sidebar-item">
                <h4>Shipping</h4>
                <p>only £2.99</p>
              </div>
              <div className="total" id="sidebar-item">
                <h4>Total</h4>
                <p>£{total.toFixed(2)}</p>
              </div>
              <button
                type="submit"
                class="btn buy"
                id="buy-btn"
                onClick={clrBasket}
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Buy
              </button>
            </div>
          </div>
        </div>
        <div className="mobile-sidebar">
          <div className="container" id="basket-sidebar-mobile">
            <div className="subTotal" id="sidebar-item-mobile">
              <h4>Subtotal</h4>£{subTotal.toFixed(2)}
            </div>
            <div className="shipping" id="sidebar-item-mobile">
              <h4>Shipping</h4>
              <p>only £2.99</p>
            </div>
            <div className="total" id="sidebar-item-mobile">
              <h4>Total</h4>£{total.toFixed(2)}
            </div>
          </div>
        </div>
      </div>
      {/* MODAL FOR BUY BUTTON  */}
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">
                Congratulations! 
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <h4>You have successfully purchased your DVDs.</h4>
              <p>They will be with you by the time your popcorn has popped!</p>
              </div>
            <div class="modal-footer">
              <button type="button" className="btn btn-primary modal-btn" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};